import React, { useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
//superadmin
import Login from './superadmin/pages/Login';
import Sidebar from './superadmin/Layouts/Sidebar';
import Dashboard from './superadmin/pages/Dashboard';
import Admins from './superadmin/pages/Admins';
// import Schoollist from './superadmin/pages/School_list';
// import Anganwadi from './superadmin/pages/Anganwadi';
import Forgotpassword from './superadmin/pages/Forgotpassword';
import Drivers from "./superadmin/pages/Drivers";
//admin
import Adminlogin from './admin/pages/Login';
import Adminsidebar from './admin/layouts/Sidebar';
import Admindashboard from './admin/pages/Dasboard';
import Adminschoollist from './admin/pages/School_list';
import AdminForgotpassword from './admin/pages/Forgotpassword';
import AdminInventory from './admin/pages/Inventory';
// import AdminTransaction from './admin/pages/Transaction';
import AdminProducts from './admin/pages/Products';
import AdminStudent from './admin/pages/Student';
import Changepassword from "./admin/pages/ResetPassword";
import SuperadminChangePassword from './superadmin/pages/SuperadminResetPassword'
import AdminDrivers from "./admin/pages/Drivers";
import PdfTemplate from "./admin/components/pdfTemplate";
import WastepickerAttendance from "./admin/pages/WastepickerAttendance";
import Reports from "./admin/pages/Reports";

function AdminRoutes() {
  return (
    <>
      <Routes>
        <Route path='/' element={<Adminsidebar />} >
          <Route path='/dashboard' element={<Admindashboard />} />
          <Route path='/transaction' element={<Adminschoollist />} />
          <Route path='/inventory' element={<AdminInventory />} />
          {/* <Route path='/transaction' element={<AdminTransaction />} /> */}
          <Route path='/Attendance' element={<AdminStudent />} />
          <Route path='/products' element={<AdminProducts />} />
          <Route path='/changePassword' element={<Changepassword />} />
          <Route path='/wastePickers' element={<AdminDrivers />} />
          <Route path='/wastePickers/:id' element={<WastepickerAttendance />} />
          <Route path='/transaction/:id' element={<PdfTemplate />} />
          <Route path='/reports' element={<Reports />} />
        </Route>
      </Routes>
    </>
  )
}

function SuperadminRoutes() {
  return (
    <>
      <Routes>
        <Route path='/' element={<Sidebar />} >
          <Route path='/dashboard' element={<Dashboard />} />
          <Route path='/admins' element={<Admins />} />
          <Route path='/admins/:adminId' element={<Drivers />} />
          {/* <Route path='/schoollist' element={<Schoollist />} /> */}
          <Route path='/changePassword' element={<SuperadminChangePassword />} />
        </Route>
      </Routes>
    </>
  )
}


function App() {
  const [triggerRefresh, setTriggerRefresh] = useState();
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");


  let authenticated = false;

  if (token) {
    authenticated = true;
  }

  if (!authenticated) {
    return (
      <>
        <Routes>
          <Route path='/superadmin' element={<Login setTriggerRefresh={setTriggerRefresh} />} />
          <Route path='/superadmin/forgotpassword' element={<Forgotpassword />} />
          <Route path='/admin' element={<Adminlogin setTriggerRefresh={setTriggerRefresh} />} />
          <Route path='/admin/forgotpassword' element={<AdminForgotpassword />} />
          <Route path="*" element={<Navigate to={"/superadmin"} />} />
        </Routes>
      </>

    )
  } else if (role === "SuperAdmin" && authenticated) {
    return (
      <>
        <Routes>
          <Route path='*' element={<Navigate to={"superadmin/dashboard"} />} />
          <Route path="/superadmin/*" element={<SuperadminRoutes />} />
          {/* <Route path="*" element={<Navigate to={"/superadmin/dashboard"} />} /> */}
        </Routes>
      </>
    )
  } else if (role === "Admin" && authenticated) {
    return (
      <>
        <Routes>
          <Route path='*' element={<Navigate to={"admin/dashboard"} />} />
          <Route path="/admin/*" element={<AdminRoutes />} />
        </Routes>
      </>
    )
  }

}

export default App;

